module.exports = __webpack_public_path__ + "static/media/best-sellers.ece15b9c.svg";